import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomePage from './pages/Home';
import Service from './pages/Services';
import Products from './pages/Products';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Values from './pages/Values';
import About from './pages/About';
import Policy from './pages/Policy';
import MainPage from './pages/main';

const AppRoutes: React.FC = () => {

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="*" element={<HomePage />} />
      <Route path='/services' element={<Service />} />
      <Route path='/products' element={<Products />} />
      <Route path='/contact' element={<Contact /> } />
      <Route path="/gallary" element={<Gallery/>} />
      <Route path="/values" element={<Values/>} />
      <Route path="/about" element={<About/>} />
      <Route path='/policy' element={<Policy/>} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
      <Router>
        <AppRoutes />
      </Router>
  );
};

export default App;
